/**
 * @param {ApiCompanyBuildingPreview} data
 * @returns {CompanyBuildingPreview}
 */
export const parseCompanyBuildingPreview = (data) => ({
  id: data.id,
  description: data.description,
  street: data.street,
  streetNumber: data.streetNumber,
  streetDetails: data.complementary,
  neighborhood: data.neighborhood,
  zipcode: data.zipcode,
  addressType: data.addressType,
  addressTypeFormat: data.addressTypeFormat,
  state: data.state,
  city: data.city,
})

/**
 * @param {ApiCompanyBuildingList} data
 * @returns {Array.<CompanyBuildingPreview>}
 */
export const parseBuildingList = (data) => {
  return data.items.map(parseCompanyBuildingPreview)
}

/**
 * @param {ApiCompanyBuildingDetails} data
 * @returns {CompanyBuildingUpdate}
 */
export const parseCompanyBuildingUpdate = (data) => ({
  id: data.id,
  description: data.description,
  zipcode: data.zipcode,
  cityId: data.cityId,
  stateId: data.stateId,
  neighborhood: data.neighborhood,
  street: data.street,
  streetNumber: data.streetNumber,
  streetDetails: data.complementary,
  addressType: data.addressType,
  isMain: data.isMain || false,
})

export default {
  parseCompanyBuildingPreview,
  parseBuildingList,
}